export enum ETemperatureSensorType {
  Output = 0,

  /**
   * Feedback sensor is hardcoded to be excluded, to include it again,
   * adjust code which refer to it (use right click, Find All References).
   */
  Feedback = 1,

  Sensor = 2,
  Target = 3,
  Average = 4,
  Minimum = 5,
  Maximum = 6,
  Fan = 7,
}
